import React, { useState, useEffect } from "react";

import NumberInput from "../../../Components/Commons/Forms/NumberInput";
import SelectField from "../../../Components/Commons/Forms/SelectField";
import BtnSave from "../../../Components/Commons/Buttons/BtnSave";
import TextArea from "../../Commons/Forms/TextArea";
import BtnClear from "../../Commons/Buttons/BtnClear";
import BtnClearDropdown from "../../Commons/Buttons/BtnClearDropdown";
import BtnDelete from "../../Commons/Buttons/BtnDelete";
import ViewPrescription from "../../AssessmentHistory/ViewPrescription";
import PrintAdmissionForm from "./PrintAdmissionForm";
import PrintDiagnostics from "../../../Pages/CheckupTabs/PrintDiagnostics";
import PrintLaboratoryDiagnostics from "../../Diagnosis/PrintLaboratoryDiagnostics";
import PrintXrayDiagnostics from "../../Diagnosis/PrintXrayDiagnostics";
import PrintCTScanDiagnostics from "../../Diagnosis/PrintCTScanDiagnostics";
import PrintUltrasoundDiagnostics from "../../Diagnosis/PrintUltrasoundDiagnostics";
import RefuseAdmissionModal from "../../../Components/Modals/RefuseAdmissionModal";

import { useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import {
  createAdmission,
  endConsultation,
  getAdmission,
  getTherapeutics,
  refuseAdmission,
  updateAdmission,
  updateCheckUp,
} from "../../Helpers/API/CheckUpApi/CheckUpApi";
import { removePatientFromQueue } from "../../Helpers/API/QueueApi/QueueApi";
import { toast } from "react-toastify";
import { formatDate, refreshPage } from "../../Helpers/Utilities/Common";
import { getVitalSigns } from "../../Helpers/API/VitalSignsApi/VitalSignsApi";
import moment from "moment";

function AdmissionForm({
  assessment_id,
  assessmentData,
  showAdmit,
  showOutPatient,
  addAdmissionData,
  setAddAdmissionData,
  patientDetails,
  diagnostics,
  printDiagnostics,
}) {
  const { id } = useParams();
  const [showViewPrescriptionModal, setShowViewPrescriptionModal] =
    useState(false);
  const [showPrintLabDiagnosticsModal, setShowPrintLabDiagnosticsModal] =
    useState(false);
  const [showPrintXrayDiagnosticsModal, setShowPrintXrayDiagnosticsModal] =
    useState(false);
  const [showPrintCTScanDiagnosticsModal, setShowPrintCTScanDiagnosticsModal] =
    useState(false);
  const [
    showPrintUltrasoundDiagnosticsModal,
    setShowPrintUltrasoundDiagnosticsModal,
  ] = useState(false);
  const [showPrintAdmissionModal, setShowPrintAdmissionModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [therapeutics, setTherapeutics] = useState([]);
  const [refuseReason, setRefuseReason] = useState("");
  const [showRefuseModal, setShowRefuseModal] = useState(false);
  const formattedCurrentDate = moment().format("MMM DD, YYYY");
  const formattedAssessmentDate = patientDetails?.added_on
    ? moment(patientDetails?.added_on).format("MMM DD, YYYY")
    : "";

  const menu = [
    { key: "laboratory", label: "Laboratory" },
    { key: "xray", label: "X-Ray" },
    { key: "ct_scan", label: "CT Scan" },
    { key: "ultrasound", label: "Ultrasound" },
  ];

  // Filter menu items where corresponding printDiagnostics type
  const filteredMenu = (() => {
    const validItems = menu.filter((item) => {
      const key = item.key;
      return (
        printDiagnostics[key] &&
        Array.isArray(printDiagnostics[key]) &&
        printDiagnostics[key].length > 0
      );
    });

    return validItems.length > 0
      ? validItems
      : [{ key: "none", label: "No diagnostics available", disabled: true }];
  })();

  // Function for showing diagnostic modal
  const handlePrintAdmission = () => {
    setShowPrintAdmissionModal(true);
  };

  // Function for showing which diagnostic to print
  function handlePrintDiagnostics(menu) {
    if (menu === "laboratory") {
      setShowPrintLabDiagnosticsModal(true);
    } else if (menu === "xray") {
      setShowPrintXrayDiagnosticsModal(true);
    } else if (menu === "ct_scan") {
      setShowPrintCTScanDiagnosticsModal(true);
    } else if (menu === "ultrasound") {
      setShowPrintUltrasoundDiagnosticsModal(true);
    }
  }

  // Function for showing rx modal
  const handlePrintRx = () => {
    fetchPatientTherapeutics();
    setShowViewPrescriptionModal(true);
  };

  // Function handling values of input fields
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddAdmissionData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Function end consultation API
  async function handleEndConsultation() {
    //Check if patient type is still for_admission
    if (patientDetails.type === "for_admission") {
      //Change patient type from for_admission into admit
      patientDetails.from_type = "for_admission";
      patientDetails.type = "admit";
      const response2 = await updateCheckUp(patientDetails, id);
      if (response2.data) {
        setIsClicked(true);
        toast.success(response2.data.message);
        const res = await endConsultation({
          assessment_id,
          type: "admit",
          status: "ended",
        });
        if (res.data) {
          toast.success(res.data.message);
          //remove patient from queue
          const res2 = await removePatientFromQueue(id);
          if (res2.data) {
            toast.success(res2.data.message);
          }
          setTimeout(() => {
            refreshPage();
          }, 1000);
        } else if (res.error) {
          toast.error(res.error);
        }
        setIsClicked(false);
      }
    } else {
      setIsClicked(true);
      const res = await endConsultation({
        assessment_id,
        type: "admit",
        status: "ended",
      });
      if (res.data) {
        toast.success(res.data.message);
        //remove patient from queue
        const res2 = await removePatientFromQueue(id);
        if (res2.data) {
          toast.success(res2.data.message);
        }
        setTimeout(() => {
          refreshPage();
        }, 1000);
      } else if (res.error) {
        toast.error(res.error);
      }
      setIsClicked(false);
    }
    // setIsClicked(true);
    // const res = await endConsultation({ assessment_id, type: "admit" });

    // if (res.data) {
    //   toast.success(res.data.message);
    //   //remove patient from queue
    //   const res2 = await removePatientFromQueue(id);
    //   if (res2.data) {
    //       toast.success(res2.data.message);
    //   }
    //   setTimeout(() => {
    //     refreshPage()
    //   }, 1000);
    // } else if (res.error) {
    //   toast.error(res.error);
    // }
    // setIsClicked(false);
  }

  // Function Add admision API
  async function addAdmission() {
    setIsClicked(true);
    const response = await createAdmission(
      addAdmissionData,
      id,
      assessment_id,
      patientDetails.doctor_id
    );
    if (response.data) {
      toast.success(response.data.message);
      patientDetails.from_type = "for_admission";
      patientDetails.type = "admit";
      const response2 = await updateCheckUp(patientDetails, id);
      if (response2.data) {
        toast.success(response2.data.message);
        showAdmit(true);
        showOutPatient(false);
      }
      setTimeout(() => {
        refreshPage();
      }, 1000);
    }
    setIsClicked(false);
  }

  async function editAdmission() {
    setIsClicked(true);
    const res = await updateAdmission(addAdmissionData);
    if (res.data) {
      toast.success(res.data.message);
      if (patientDetails.type === "for_admission") {
        patientDetails.from_type = "for_admission";
        patientDetails.type = "admit";
        const response2 = await updateCheckUp(patientDetails, id);
        if (response2.data) {
          toast.success(response2.data.message);
          showAdmit(true);
          showOutPatient(false);
        }
        setTimeout(() => {
          refreshPage();
        }, 1000);
      }
    } else if (res.error) {
      toast.error(res.error);
    }
    setIsClicked(false);
  }

  // Function get admission API
  async function fetchAdmission() {
    const res = await getAdmission({
      patient_id: id,
      assessment_id: assessment_id,
    });

    if (res.data) {
      setAddAdmissionData(res.data.data[0]);
    } else if (res.error) {
      setAddAdmissionData({
        problem: "",
        health_condition: "",
        vital_signs: "",
        ambulation: "",
        iso_precaution: "",
        diet: "",
        tpr: "",
        ivf: "",
        i_and_o: "",
        plan: "",
      });
    }
  }

  // Function get patient therapeutics API
  async function fetchPatientTherapeutics() {
    const res = await getTherapeutics({
      patient_id: id,
      assessment_id: assessment_id,
    });
    if (res.data) {
      const filtered = (Array.isArray(res.data) ? res.data : []).filter(
        (t) => t?.quantity !== undefined && t?.quantity !== null && t?.quantity !== "" && t?.quantity !== "null"
      );
      setTherapeutics(filtered);
    } else if (res.error) {
      setTherapeutics([]);
    }
  }

  async function handleRefuseAdmission() {
    setIsClicked(true);
    const res = await refuseAdmission({
      assessment_id: assessment_id,
      reason: refuseReason,
    });

    if (res.data) {
      toast.success(res.data.message);
      setTimeout(() => {
        refreshPage();
      }, 1000);
    } else if (res.error) {
      toast.error(res.error);
    }
    setIsClicked(false);
  }

  useEffect(() => {
    if (assessment_id) {
      fetchAdmission();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessment_id]);

  return (
    <div className="tabs-box p-3">
      <div className="col pt-1">
        <div className="">
          <div className="row mt-2">
            <div className="col-sm-12">
              <div className="row">
                <div className="col mb-2">
                  <span>Detailed Vital Signs on Current Visit</span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <NumberInput
                    id="weight"
                    name="weight"
                    formLabel={`Weight (kg)`}
                    size={`sm`}
                    value={assessmentData?.latest_vital_sign?.weight}
                    disabled={true}
                  />
                </div>
                <div className="col-sm-3">
                  <NumberInput
                    id="weight"
                    name="weight"
                    formLabel={`Height (cm)`}
                    size={`sm`}
                    value={assessmentData?.latest_vital_sign?.height}
                    disabled={true}
                  />
                </div>
                <div className="col-sm-3">
                  <NumberInput
                    id="temperature"
                    name="temperature"
                    formLabel={`Temperature (°C)`}
                    size={`sm`}
                    value={assessmentData?.latest_vital_sign?.temperature}
                    disabled={true}
                  />
                </div>
                <div className="col-sm-3">
                  <NumberInput
                    id="bp"
                    name="bp"
                    formLabel={`Blood Pressure (mmHg)`}
                    size={`sm`}
                    value={assessmentData?.latest_vital_sign?.bp}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <NumberInput
                    id="heart_rate"
                    name="heart_rate"
                    formLabel={`Heart Rate (bpm)`}
                    size={`sm`}
                    value={assessmentData?.latest_vital_sign?.heart_rate}
                    disabled={true}
                  />
                </div>
                <div className="col-sm-3">
                  <NumberInput
                    id="respiratory_rate"
                    name="respiratory_rate"
                    formLabel={`Respiratory Rate`}
                    size={`sm`}
                    value={assessmentData?.latest_vital_sign?.respiratory_rate}
                    disabled={true}
                  />
                </div>
                <div className="col-sm-3">
                  <NumberInput
                    id="oxygen_saturation"
                    name="oxygen_saturation"
                    formLabel={`Oxygen Saturation`}
                    size={`sm`}
                    value={assessmentData?.latest_vital_sign?.oxygen_saturation}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <TextArea
                    id="problem"
                    name="problem"
                    formLabel={`Problem`}
                    size={`sm`}
                    value={addAdmissionData?.problem}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <SelectField
                    formLabel={`Condition`}
                    name="health_condition"
                    size={`sm`}
                    placeholder={"SELECT"}
                    options={[
                      { value: "", label: "SELECT" },
                      { value: "critical", label: "Critical" },
                      { value: "guarded", label: "Guarded" },
                      { value: "stable", label: "Stable" },
                    ]}
                    value={addAdmissionData?.health_condition}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
                <div className="col-sm-6">
                  <SelectField
                    formLabel={`Vital Signs Monitoring`}
                    name="vital_signs"
                    size={`sm`}
                    placeholder={"SELECT"}
                    options={[
                      { value: "", label: "SELECT" },
                      { value: "q_2h", label: "q 2H" },
                      { value: "q_4h", label: "q 4H" },
                      { value: "q_hourly", label: "q Hourly" },
                      // { value: "q_shift", label: "q Shift" },
                    ]}
                    value={addAdmissionData?.vital_signs}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <SelectField
                    formLabel={`Ambulation  `}
                    name="ambulation"
                    size={`sm`}
                    placeholder={"SELECT"}
                    options={[
                      { value: "", label: "SELECT" },
                      { value: "CBR with TP", label: "CBR with TP" },
                      { value: "CBR without TP", label: "CBR without TP" },
                      {
                        value: "May use Bedside Commode",
                        label: "May use Bedside Commode",
                      },
                      { value: "No Restriction", label: "No Restriction" },
                    ]}
                    value={addAdmissionData?.ambulation}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
                <div className="col-sm-6">
                  <SelectField
                    formLabel={`Isolation Precaution`}
                    name="iso_precaution"
                    size={`sm`}
                    placeholder={"SELECT"}
                    options={[
                      { value: "", label: "SELECT" },
                      { value: "q_2h", label: "q 2H" },
                      { value: "q_4h", label: "q 4H" },
                      { value: "q_hourly", label: "q Hourly" },
                      { value: "q_shift", label: "q Shift" },
                    ]}
                    value={addAdmissionData?.iso_precaution}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <TextArea
                    id="labs"
                    name="labs"
                    formLabel={`Labs`}
                    size={`sm`}
                    value={addAdmissionData?.labs}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
                <div className="col-sm-6">
                  <TextArea
                    id="xray"
                    name="xray"
                    formLabel={`Imaging`}
                    size={`sm`}
                    value={addAdmissionData?.xray}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <TextArea
                    id="treatment"
                    name="treatment"
                    formLabel={`Treatment/Medication`}
                    size={`sm`}
                    value={addAdmissionData?.treatment}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <TextArea
                    id="diet"
                    name="diet"
                    formLabel={`Diet`}
                    size={`sm`}
                    value={addAdmissionData?.diet}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <TextArea
                    id="ivf"
                    name="ivf"
                    formLabel={`IVF`}
                    size={`sm`}
                    value={addAdmissionData?.ivf}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
              </div>
              <div className="row">
                {/* <div className="col-sm-6">
                  <SelectField
                    formLabel={`TPR  `}
                    name="tpr"
                    size={`sm`}
                    placeholder={"SELECT"}
                    options={[
                      { value: "", label: "SELECT" },
                      { value: "q_2h", label: "q 2H" },
                      { value: "q_4h", label: "q 4H" },
                      { value: "q_hourly", label: "q Hourly" },
                    ]}
                    value={addAdmissionData?.tpr}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div> */}
                <div className="col-sm-6">
                  <SelectField
                    formLabel={`I and O`}
                    name="i_and_o"
                    size={`sm`}
                    placeholder={"SELECT"}
                    options={[
                      { value: "", label: "SELECT" },
                      { value: "q_2h", label: "q 2H" },
                      { value: "q_4h", label: "q 4H" },
                      { value: "q_hourly", label: "q Hourly" },
                      { value: "q_shift", label: "q Shift" },
                    ]}
                    value={addAdmissionData?.i_and_o}
                    onChange={handleAddChange}
                    disabled={isClicked}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <TextArea
                    id="plan"
                    name="plan"
                    formLabel={`Plan/Other Notes`}
                    size={`sm`}
                    onChange={handleAddChange}
                    value={addAdmissionData?.plan}
                    disabled={isClicked}
                  />
                </div>
              </div>
            </div>
          </div>

          {addAdmissionData?.id ? (
            <>
              <Row className="justify-content-end mt-5 mb-3">
                <Col xs={3} className="col-container">
                  <BtnClear
                    label={"Print Rx"}
                    size={"sm"}
                    onClick={handlePrintRx}
                  />
                </Col>
                <Col xs={3} className="col-container">
                  <BtnClearDropdown
                    label={"Print Diagnostics"}
                    size={"sm"}
                    menuItems={filteredMenu}
                    onSelect={(key) => {
                      if (key !== "none") handlePrintDiagnostics(key);
                    }}
                    disabled={false}
                  />
                </Col>
                <Col xs={3} className="col-container">
                  <BtnClear
                    label={"Print Admission Form"}
                    size={"sm"}
                    onClick={handlePrintAdmission}
                  />
                </Col>
                <Col xs={3} className="col-container">
                  <BtnSave
                    label={"Save Changes"}
                    size={"sm"}
                    onClick={editAdmission}
                    isClicked={isClicked}
                    disabled={
                      //disable button if all of these fields are null or empty string
                      (addAdmissionData.problem === "" ||
                        addAdmissionData.problem === null) &&
                      (addAdmissionData.diet === "" ||
                        addAdmissionData.diet === null) &&
                      (addAdmissionData.ivf === "" ||
                        addAdmissionData.ivf === null) &&
                      (addAdmissionData.plan === "" ||
                        addAdmissionData.plan === null)
                    }
                  />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row className="justify-content-end mt-5 mb-3">
                {/*Patient can only refuse admission 3 times*/}
                {parseInt(patientDetails?.refused_count) < 3 && (
                  <>
                    <Col xs={3} className="col-container">
                      <BtnDelete
                        label={"Refuse Admission"}
                        size={"sm"}
                        onClick={() => setShowRefuseModal(true)}
                        isClicked={isClicked}
                      />
                    </Col>
                  </>
                )}
                <Col xs={3} className="col-container">
                  <BtnSave
                    label={"Submit Admission Form"}
                    size={"sm"}
                    onClick={addAdmission}
                    isClicked={isClicked}
                    disabled={Object.values(addAdmissionData).every(
                      (value) => value === ""
                    )}
                  />
                </Col>
              </Row>
            </>
          )}
          {addAdmissionData?.id && (
            <>
              <Row className="justify-content-end ">
                {/*Patient can only refuse admission 3 times*/}
                {parseInt(patientDetails?.refused_count) < 3 && (
                  <>
                    <Col xs={3} className="col-container">
                      <BtnDelete
                        label={"Refuse Admission"}
                        size={"sm"}
                        onClick={() => setShowRefuseModal(true)}
                        isClicked={isClicked}
                      />
                    </Col>
                  </>
                )}
                <Col xs={3} className="col-container">
                  <BtnDelete
                    label={"End Consultation"}
                    size={"sm"}
                    onClick={handleEndConsultation}
                    isClicked={isClicked}
                  />
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>

      <ViewPrescription
        show={showViewPrescriptionModal}
        onHide={() => setShowViewPrescriptionModal(false)}
        therapeutics={therapeutics}
        assessmentId={assessment_id}
        patient={{
          ...patientDetails,
          assessment_date:
            patientDetails.is_sunday_patient !== "1"
              ? formatDate(patientDetails.added_on)
              : formatDate(patientDetails.last_checkup_date),
          address: [
            patientDetails?.street,
            patientDetails?.barangay,
            patientDetails?.province,
            patientDetails?.city,
            patientDetails?.zip_code,
          ]
            .filter(Boolean)
            .join(", "),
        }}
        doctor={patientDetails}
      />
      {/* <PrintDiagnostics
        show={showPrintDiagnosticsModal}
        onHide={() => setShowPrintDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessment_id}
        patient={patientDetails}
      /> */}

      <PrintLaboratoryDiagnostics
        show={showPrintLabDiagnosticsModal}
        onHide={() => setShowPrintLabDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessment_id}
        patient={patientDetails}
      />

      <PrintXrayDiagnostics
        show={showPrintXrayDiagnosticsModal}
        onHide={() => setShowPrintXrayDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessment_id}
        patient={patientDetails}
      />

      <PrintCTScanDiagnostics
        show={showPrintCTScanDiagnosticsModal}
        onHide={() => setShowPrintCTScanDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessment_id}
        patient={patientDetails}
      />

      <PrintUltrasoundDiagnostics
        show={showPrintUltrasoundDiagnosticsModal}
        onHide={() => setShowPrintUltrasoundDiagnosticsModal(false)}
        diagnostics={diagnostics}
        printDiagnostics={printDiagnostics}
        assessmentId={assessment_id}
        patient={patientDetails}
      />

      <PrintAdmissionForm
        show={showPrintAdmissionModal}
        onHide={() => setShowPrintAdmissionModal(false)}
        assessmentData={assessmentData}
        latestVitalSigns={assessmentData.latest_vital_sign}
        addAdmissionData={addAdmissionData}
        assessmentId={assessment_id}
        patient={patientDetails}
      />

      <RefuseAdmissionModal
        show={showRefuseModal}
        onHide={() => {
          setRefuseReason("");
          setShowRefuseModal(false);
        }}
        refuseReason={refuseReason}
        onChange={(e) => setRefuseReason(e.target.value)}
        onConfirm={handleRefuseAdmission}
        isClicked={isClicked}
      />
    </div>
  );
}

export default AdmissionForm;
